import { api } from "boot/axios";
import { LocalStorage } from "quasar";
import { Notify } from "quasar";

export function login(
  { commit },
  {
    username,
    password,
    device,
    medium,
    hostname,
    sweta,
    prabhu,
    arthasarokar,
    globalimecapital,
  }
) {
  return new Promise((resolve, reject) => {
    let clintList = [sweta, prabhu, arthasarokar, globalimecapital];
    api
      .post("/authenticate/v2/token/", {
        phone_number: username,
        password: password,
        device: device,
        medium: medium,
      })
      .then((response) => {
        commit("setToken", response.data);
        api.defaults.headers.common[
          "Authorization"
        ] = `Bearer ${response.data.access}`;
        resolve(response.data);
      })
      .catch((error) => {
        console.log("error", { error });
        reject(error);
      });
  });
}

export function refresh({ commit }, { refreshToken }) {
  return new Promise((resolve, reject) => {
    let url = LocalStorage.getItem("validatingOtp")
      ? "/authenticate/v2/token/refresh/"
      : "/authenticate/v2/token/refresh/";
    api
      .post(url, {
        refresh: refreshToken,
      })
      .then((response) => {
        commit("updateToken", response.data);
        api.defaults.headers.common[
          "Authorization"
        ] = `Bearer ${response.data.access}`;
        resolve(response.data);
      })
      .catch((error) => {
        console.error({ error });
        reject(error);
      });
  });
}

export const logout = ({ commit }) => {
  return new Promise((resolve,reject)=>{
    api
      .post("/authenticate/v2/logout/", {
        refresh: LocalStorage.getItem("token").refresh,
      })
      .then(() => {
        commit("purgeToken");
        api.defaults.headers.common.Authorization = "";
        resolve()
      })
      .catch((error) => {
        commit("purgeToken");
        api.defaults.headers.common.Authorization = "";
        reject()
      });
  })
};
let count = 0;
export const purgeToken = ({ commit }) => {
  commit("purgeToken");
  api.defaults.headers.common.Authorization = "";
  if (count == 0)
    Notify.create({
      message: "Session Expired",
    });
  count += 1;
};
